"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const functions_1 = require("@/common/functions");
function default_1({ thumbnail, roomId, maxWidth768, isMasonryMobile, isStoryCard, }) {
    const thumbnailUrl = (0, functions_1.getCdnUrl)(thumbnail) ||
        (isStoryCard
            ? `${process.env.CDN_URL}/story/background/story_background_default.webp`
            : `${process.env.CDN_URL}/assets/images/thumbnail-${(0, functions_1.fixedRemainder)(roomId !== null && roomId !== void 0 ? roomId : 0, 12)}.webp`);
    return ((0, jsx_runtime_1.jsx)("img", { src: thumbnailUrl, css: {
            width: '100%',
            minHeight: maxWidth768 && isMasonryMobile ? '132px' : 'unset',
            maxHeight: maxWidth768 && isMasonryMobile ? '200px' : 'unset',
            borderRadius: '10px',
            objectFit: 'cover',
            transition: 'transform 0.3s',
            WebkitBackfaceVisibility: 'hidden',
            WebkitTransform: 'translateZ(0)',
            transform: 'translateZ(0)',
            '&:hover': {
                WebkitTransform: 'scale(1.1)',
                transform: 'scale(1.1)',
            },
        }, draggable: "false" }));
}
exports.default = default_1;
